<template>
  <div>
    <!-- ===== Modal List Identitas ===== -->
    <b-modal
      id="modal-identitas-list-c"
      size="xl"
      title="Identitas Nasabah"
      hide-footer
      @shown="onModalIdentitasShown"
      @hidden="onCloseIdentitas"
    >
      <div class="mb-3 d-flex justify-content-between align-items-center">
        <div class="d-flex" style="align-items: center; gap: 8px;">
          <span>
            {{ dataAnggota.nama }} -
          </span>
          <span class="status-box status-box-brand">{{ dataAnggota.no }}</span>
          <b-alert v-if="isEdit" show class="p-0 mb-0 px-2" style="font-weight: 600;">{{ titleInformasiEdit }}</b-alert>
        </div>
        <div v-if="!isEdit">
          <b-button
            size="sm"
            variant="success"
            @click="$bvModal.show('modal-identitas-add-c')"
          >
            + Tambah Identitas
          </b-button>
        </div>
      </div>

      <div v-if="isLoadIdentitas">...load</div>
      <div v-else>
        <b-table
          :items="identitasList"
          :fields="[
            { key: 'jenisIdentitas', label: 'Jenis / No Identitas' },
            {
              key: 'noIdentitas',
              label: 'No Identitas',
              class: 'd-none d-sm-table-cell',
            },
            { key: 'aksi', label: 'Aksi' },
          ]"
          small
          bordered
          responsive
        >
          <!-- Gabungan utk mobile -->
          <template #cell(jenisIdentitas)="{ item }">
            <div class="d-sm-none">
              <div>
                <strong>{{ item.jenisIdentitas }}</strong>
              </div>
              <div class="text-muted">{{ item.noIdentitas }}</div>
            </div>
            <!-- Desktop tetap tampil jenis identitas -->
            <div class="d-none d-sm-block">
              {{ item.jenisIdentitas }}
            </div>
          </template>

          <template #cell(fotoIdentitas)="{ item }">
            <div class="d-flex align-items-center">
              <img
                :src="item.fotoIdentitas"
                alt="foto"
                style="
                  width: 56px;
                  height: 56px;
                  object-fit: cover;
                  border-radius: 6px;
                  border: 1px solid #eee;
                "
              />
            </div>
          </template>

          <template #cell(aksi)="{ item }">
            <div class="flex">
              <b-button
                v-if="!isEdit"
                size="sm"
                class="table-button edit mr-2"
                title="Edit"
                @click="editDataIdentitas(item)"
              >
                <i class="fa fa-pencil-square-o"></i>
              </b-button>

              <b-button
                size="sm"
                variant="pgiBtn"
                name="bayarBtn"
                @click="openPreview(item.fotoIdentitas)"
              >
                <i class="fa fa-picture-o" aria-hidden="true"></i>
              </b-button>
            </div>
          </template>
        </b-table>
      </div>
    </b-modal>

    <!-- ===== Modal Tambah Identitas ===== -->
    <b-modal
      id="modal-identitas-add-c"
      title="Tambah Identitas"
      size="xl"
      :no-close-on-backdrop="addingIdentitas"
      :no-close-on-esc="addingIdentitas"
      :hide-header-close="addingIdentitas"
    >
      <b-form>
        <b-form-group label="Jenis Identitas" label-for="addJenis">
          <b-form-select
            id="addJenis"
            v-model="formAddIdentitas.jenisIdentitasId"
            :options="jenisIdentitas"
            placeholder="Pilih Identitas"
            required
          >
            <template #first>
              <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
            </template>
          </b-form-select>
        </b-form-group>

        <b-form-group label="No Identitas" label-for="addNo">
          <b-form-input
            id="addNo"
            v-model="formAddIdentitas.noIdentitas"
            required
            maxlength="32"
            placeholder="cth: 3201xxxxxxxxxxxx"
          />
        </b-form-group>

        <div class="wrap d-flex flex-column flex-md-row">
          <FotoPendukung
            :isNotShowCam="true"
            :fotoPendukung="foto"
            :length="1"
            :minLength="1"
            @showModalPreview="openModalPreview"
            @onChange="onChangeFotoAddIdentitas"
          />
          <div class="right mt-3 mt-md-0 ml-md-4">
            <label class="font-weight-bold d-block mb-2">* Contoh pengambilan foto</label>
            <div class="foto-input-wrapper">
              <div class="foto-preview-wrapper-potrait">
                <img
                  src="../../../public/img/Screenshot 2023-06-19 at 11.40.20.jpg"
                  alt="Contoh KTP"
                  style="border: 1px solid #eee; border-radius: 6px"
                />
              </div>
            </div>
          </div>
        </div>

        <!-- <b-alert variant="info" show v-if="addingIdentitas" class="mt-3">
          Mengunggah foto & menyimpan data…
        </b-alert> -->
      </b-form>

      <template v-slot:modal-footer="{ cancel }">
        <b-button variant="secondary" @click="cancel()" :disabled="addingIdentitas">
          Cancel
        </b-button>
        <b-button variant="primary" @click="onAddIdentitas()" :disabled="addingIdentitas">
          {{ addingIdentitas ? 'Mengirim...' : 'Submit' }}
        </b-button>
      </template>
    </b-modal>

    <!-- ===== Modal Edit Identitas ===== -->
    <b-modal
      id="modal-identitas-edit-c"
      title="Edit Identitas"
      size="xl"
      :no-close-on-backdrop="savingEdit"
      :no-close-on-esc="savingEdit"
      :hide-header-close="savingEdit"
    >
      <b-form>
        <b-form-group label="Jenis Identitas" label-for="editJenis">
          <!-- tetap gunakan input readonly sesuai kode awal (tidak ubah field) -->
          <b-form-input
            id="editJenis"
            v-model="formEditIdentitas.jenisIdentitas"
            disabled
          />
        </b-form-group>

        <b-form-group label="No Identitas" label-for="editNo">
          <b-form-input
            id="editNo"
            v-model="formEditIdentitas.noIdentitas"
            required
            maxlength="32"
            placeholder="cth: 3201xxxxxxxxxxxx"
          />
        </b-form-group>

        <div class="wrap d-flex flex-column flex-md-row">
          <FotoPendukung
            :isNotShowCam="true"
            :isRemove="false"
            :isShowFoto="true"
            :fotoUrl="formEditIdentitas.fotoIdentitas"
            :fotoPendukung="fotoEdit"
            :length="1"
            :minLength="1"
            @openPreview="openPreview"
            @showModalPreview="openModalPreview"
            @onChange="onChangeFotoEditIdentitas"
          />
          <div class="right mt-3 mt-md-0 ml-md-4">
            <label class="font-weight-bold d-block mb-2">* Contoh pengambilan foto</label>
            <div class="foto-input-wrapper">
              <div class="foto-preview-wrapper-potrait">
                <img
                  src="../../../public/img/Screenshot 2023-06-19 at 11.40.20.jpg"
                  alt="Contoh KTP"
                  style=" border: 1px solid #eee; border-radius: 6px"
                />
              </div>
            </div>
          </div>
        </div>

        <!-- <b-alert variant="info" show v-if="savingEdit" class="mt-3">
          Menyimpan perubahan & mengirim semua identitas…
        </b-alert> -->
      </b-form>

      <template v-slot:modal-footer="{ cancel }">
        <b-button variant="secondary" @click="cancel()" :disabled="savingEdit">
          Cancel
        </b-button>
        <b-button variant="primary" @click="onSaveEdit()" :disabled="savingEdit">
          {{ savingEdit ? 'Mengirim...' : 'Submit' }}
        </b-button>
      </template>
    </b-modal>
    <ModalPreview modalId="modal-preview-gadai-i" :fotoPreview="activeFotoPreview" />
  </div>
</template>

<script>
import DataFoto from "../../components/anggota/DataFoto";
import FotoPendukung from "../../components/webcam/FotoPendukung";
import ModalPreview from "../../components/webcam/ModalPreview";

export default {
  components: {
    DataFoto,
    FotoPendukung,
    ModalPreview
  },
  props: {
    isModal: { type: Boolean, default: false },
    idAnggota: { type: Number },
    dataAnggota: { type: Object },
    requiredForDataKerabatAndPihakLain: { type: Boolean },
    getListAnggota: { type: Function },
    isEdit: { type: Boolean },
    titleInformasiEdit: { type: String },
  },
  data() {
    return {
      input: {
        dataIdentitas: {
          nama: "",
          email: "Pugindo@gmail.com",
          jenisIdentitas: null,
          noIdentitas: "",
          jenisKelamin: null,
          statusKawin: null,
          kewarganegaraan: null,
          kotaLahir: "",
          tanggalLahir: "",
          kotaKtp: {},
          kecamatanKtp: null,
          kelurahanDesaKtp: null,
          rtKtp: "",
          rwKtp: "",
          alamatKtp: "",
          alamatKerja: "",
          telpKerja: "",
          pekerjaanBaru: null,
          listKecamatan: [],
          listKelurahan: [],
          kecLoading: false,
          kelLoading: false,
        },
      },

      jenisIdentitas: [],
      resetSection: null,
      newNasabahId: null,
      identitasList: [],

      savingAll: false,
      savingRowId: null,

      // tambah
      addingIdentitas: false,
      formAddIdentitas: {
        jenisIdentitasId: null,
        noIdentitas: "",
        file: null,
        preview: null,
      },

      // edit
      editingIndex: -1,
      savingEdit: false,
      formEditIdentitas: {
        id: null,
        nasabahId: null,
        identitasId: null,
        noIdentitas: "",
        fotoIdentitas: null,
        jenisIdentitas: "",
        jenisIdentitasId: null,
      },

      // foto add
      foto: {
        index: 0,
        fotoBarangPendukung: null,
        fotoBarangPendukungBase64: null,
        activeFotoPendukungBase64: null,
        urlFotoBarangPendukung: null,
        checkFotoBarangPendukung: false,
        fotoBarangPendukungPlaceholder: "Pilih Foto",
      },

      // foto edit
      fotoEdit: {
        index: 0,
        fotoBarangPendukung: null,
        fotoBarangPendukungBase64: null,
        activeFotoPendukungBase64: null,
        urlFotoBarangPendukung: null,
        checkFotoBarangPendukung: false,
        fotoBarangPendukungPlaceholder: "Pilih Foto",
      },

      // loader list
      isLoadIdentitas: false,
      activeFotoPreview: "",
      fotoUrlAddIdentitas: '',
      fotoUrlEditIdentitas: '',
    };
  },

  methods: {
    onModalIdentitasShown() {
      this.getIdentity();
      this.fetchIdentitasList();
    },
    onChangeAddPhoto() {
      return (e) => {
        const f = e.target.files && e.target.files[0];
        if (!f) return;
        this.formAddIdentitas.file = f;
        this.formAddIdentitas.preview = URL.createObjectURL(f);
      };
    },
    async getIdentity() {
      await this.$axios.get("nasabah/jenis-identitas").then((response) => {
        this.jenisIdentitas = [];
        for (const data of response.data) {
          this.jenisIdentitas.push({ value: data.id, text: data.name });
        }
      });
    },

    async fetchIdentitasList() {
      this.isLoadIdentitas = true;
      const res = await this.$axios.get(
        `nasabah/get-nasabah-identitas?page=0&size=100&nasabahNo=${this.dataAnggota.no}`
      );
      this.identitasList = this.safeGetIdentitas(res);

      this.isLoadIdentitas = false;
    },

    async onAddIdentitas() {
      if (!this.fotoUrlAddIdentitas) {
        this.$helper.toastErr(this, "Harap upload terlebih dahulu.");
        return;
      }
      
      try {
        this.addingIdentitas = true;
        
        const payload = [
          {
            nasabahId: Number(this.dataAnggota.id),
            jenisIdentitasId: Number(this.formAddIdentitas.jenisIdentitasId),
            noIdentitas: String(this.formAddIdentitas.noIdentitas || "").trim(),
            fotoIdentitas: this.fotoUrlAddIdentitas,
          },
        ];

        const addRes = await this.$axios.post(
          "nasabah/create-nasabah-identitas",
          payload,
          { headers: { "Content-Type": "application/json" } }
        );

        const newId = addRes.data.id || "tmp-" + Date.now();
        this.identitasList.push({
          id: newId,
          nasabahId: this.dataAnggota.id,
          jenisIdentitasId: this.formAddIdentitas.jenisIdentitasId,
          noIdentitas: this.formAddIdentitas.noIdentitas,
          fotoIdentitas: this.fotoUrlAddIdentitas,
          _dirty: false,
        });

        this.fetchIdentitasList(this.dataAnggota.no);
        if (this.getListAnggota) {
          this.getListAnggota(this.dataAnggota.no);
        }
        this.$helper.toastSucc(this, "Identitas berhasil ditambahkan");
        this.formAddIdentitas = {
          jenisIdentitasId: null,
          noIdentitas: "",
          file: null,
          preview: null,
        };
        this.$bvModal.hide("modal-identitas-add-c");

        this.foto={
          index: 0,
          fotoBarangPendukung: null,
          fotoBarangPendukungBase64: null,
          activeFotoPendukungBase64: null,
          urlFotoBarangPendukung: null,
          checkFotoBarangPendukung: false,
          fotoBarangPendukungPlaceholder: "Pilih Foto",
        }
        this.fotoUrlAddIdentitas = '';
      } catch (error) {
        this.$helper.parseError(this, error)
      } finally {
        this.addingIdentitas = false;
      }
    },
    editDataIdentitas(item) {
      
      this.editingIndex = this.identitasList.findIndex(
        (x) => x.identitasId === item.identitasId
      );

      const jenisId =
        item && item.identitasId != null
          ? item.identitasId
          : item && item.jenis_identitas_id != null
          ? item.jenis_identitas_id
          : item && item.jenisIdentitas && item.jenisIdentitas.id != null
          ? item.jenisIdentitas.id
          : null;

      const noIdentitas =
        item && item.noIdentitas != null && item.noIdentitas !== ""
          ? item.noIdentitas
          : item && item.no_identitas != null
          ? item.no_identitas
          : "";

      const fotoIdentitas =
        item && item.fotoIdentitas != null
          ? item.fotoIdentitas
          : item && item.foto_identitas != null
          ? item.foto_identitas
          : null;

      const nasabahId =
        item && item.nasabahId != null ? item.nasabahId : this.newNasabahId;

      this.formEditIdentitas = {
        id: item.identitasId,
        nasabahId: this.dataAnggota.id,
        identitasId: jenisId,
        noIdentitas: noIdentitas,
        fotoIdentitas: fotoIdentitas,
        jenisIdentitas: item.jenisIdentitas,
        jenisIdentitasId: item.jenisIdentitasId,
      };

      this.fotoEdit={
        index: 0,
        fotoBarangPendukung: null,
        fotoBarangPendukungBase64: null,
        activeFotoPendukungBase64: null,
        urlFotoBarangPendukung: null,
        checkFotoBarangPendukung: false,
        fotoBarangPendukungPlaceholder: "Pilih Foto",
      }
      this.fotoUrlEditIdentitas = '';

      this.$bvModal.show("modal-identitas-edit-c");
    },

    async onSaveEdit() {
      try {
        this.savingEdit = true;
        if (this.fotoUrlEditIdentitas) {
          const updated = {
            id: this.formEditIdentitas.identitasId,
            noIdentitas: this.formEditIdentitas.noIdentitas,
            fotoIdentitas: this.fotoUrlEditIdentitas,
            nasabahId: this.dataAnggota.id,
            jenisIdentitasId: this.formEditIdentitas.jenisIdentitasId,
          };

          await this.$axios.put(
            `nasabah/update-nasabah-identitas/${this.formEditIdentitas.identitasId}`,
            updated
          );

          this.$helper.toastSucc(this, "Identitas berhasil diupdate");
          this.fetchIdentitasList(this.dataAnggota.no);
          if (this.getListAnggota) {
            this.getListAnggota(this.dataAnggota.no);
          }
          this.$bvModal.hide("modal-identitas-edit-c");

        }else{

          const updated = {
            id: this.formEditIdentitas.identitasId,
            noIdentitas: this.formEditIdentitas.noIdentitas,
            fotoIdentitas: this.formEditIdentitas.fotoIdentitas,
            nasabahId: this.dataAnggota.id,
            jenisIdentitasId: this.formEditIdentitas.jenisIdentitasId,
          };

          const res = await this.$axios.put(
            `nasabah/update-nasabah-identitas/${this.formEditIdentitas.identitasId}`,
            updated
          );

          this.$helper.toastSucc(this, "Identitas berhasil diupdate");
          this.fetchIdentitasList(this.dataAnggota.no);
          if (this.getListAnggota) {
            this.getListAnggota(this.dataAnggota.no);
          }
          this.$bvModal.hide("modal-identitas-edit-c");
        }
        this.fotoEdit={
          index: 0,
          fotoBarangPendukung: null,
          fotoBarangPendukungBase64: null,
          activeFotoPendukungBase64: null,
          urlFotoBarangPendukung: null,
          checkFotoBarangPendukung: false,
          fotoBarangPendukungPlaceholder: "Pilih Foto",
        }
        this.fotoUrlEditIdentitas = '';
      } catch (error) {
        this.$helper.parseError(this, error);
        this.fetchIdentitasList(this.dataAnggota.no);
      } finally {
        this.savingEdit = false;
      }
    },

    onCloseIdentitas() {
      const datas = { ...this.dataModalAnggota, identitas: this.identitasList };
      this.$bvModal.hide("modal-confirm-edit");
      this.$emit("updateModalAnggota", datas);
    },

    openPreview(foto) {
      this.activeFotoPreview = foto;
      this.$bvModal.show("modal-preview-gadai-i");
    },

    openModalPreview(){
        this.activeFotoPreview = this.fotoEdit.activeFotoPendukungBase64 || this.foto.activeFotoPendukungBase64
        this.$bvModal.show("modal-preview-gadai-i")
    },
    safeGetIdentitas(res) {
      if (
        res &&
        res.data &&
        res.data.content &&
        res.data.content.length > 0 &&
        res.data.content[0].identitas
      ) {
        return res.data.content[0].identitas.map((x) => ({
          ...x,
          _dirty: false,
        }));
      }
      return [];
    },
    async onChangeFotoAddIdentitas(file, index) {
      const fileUpload = this.$helper.createSafeFileCopy(file);
      const path = 'nasabah/create-identitas-presigned-url';
      const params = { nasabahNo: this.dataAnggota.no };

      this.$store.dispatch("loading/show")
      const response = await this.$helper.uploadPresigned({ vue: this, path, params, fileUpload })
      this.$store.dispatch("loading/hide")

      if (!response.success) {
          this.foto = {
            index: 0,
            fotoBarangPendukung: null,
            fotoBarangPendukungBase64: null,
            activeFotoPendukungBase64: null,
            urlFotoBarangPendukung: null,
            checkFotoBarangPendukung: false,
            fotoBarangPendukungPlaceholder: "Pilih Foto",
          }
          this.$helper.toastErr(this, "Gagal upload foto. Silakan coba lagi.");
          return;
      }

      const url = response.publicUrl;
      this.fotoUrlAddIdentitas = url;
    },
    async onChangeFotoEditIdentitas(file, index) {
      const fileUpload = this.$helper.createSafeFileCopy(file);
      const path = 'nasabah/create-identitas-presigned-url';
      const params = { nasabahNo: this.dataAnggota.no };

      this.$store.dispatch("loading/show")
      const response = await this.$helper.uploadPresigned({ vue: this, path, params, fileUpload })
      this.$store.dispatch("loading/hide")

      if (!response.success) {
          this.fotoEdit = {
            index: 0,
            fotoBarangPendukung: null,
            fotoBarangPendukungBase64: null,
            activeFotoPendukungBase64: null,
            urlFotoBarangPendukung: null,
            checkFotoBarangPendukung: false,
            fotoBarangPendukungPlaceholder: "Pilih Foto",
          }
          this.$helper.toastErr(this, "Gagal upload foto. Silakan coba lagi.");
          return;
      }

      const url = response.publicUrl;
      this.fotoUrlEditIdentitas = url;
    },
  },
};
</script>
<style scoped>
.wrap {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}
.right img {
  max-width: 100%;
  height: auto;
  display: block;
}
@media (min-width: 1024px) {
  .wrap {
    flex-direction: row;
    align-items: flex-start;
  }
  .right {
    margin-left: 2.5rem;
    width: 50%;
  }
  .wrap > :first-child {
    width: 50%;
  }
}
</style>
